module.exports = __webpack_public_path__ + "static/media/idacard-N.3e7d4d88.PNG";